import Svg15 from "@assets/icons/svg15.svg?react";
import style from "./index.module.scss";
import useTranslate from "@/hooks/useTranslate";
export default function Loading() {
  const { $t } = useTranslate();
  return (
    <div className="w-100 h-100 rounded-5 flex flex-col justify-start items-center p-[10px_0] gap-y-8 ml-[50%] mt-[50%] translate-[-50%]">
      <Svg15 className={style.animate} style={{ width: "100%" }} />
      <p className="font-400 color-[var(--app-text-04)]">{$t("title32")}</p>
    </div>
  );
}
